import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { Icon } from '@weareconceptstudio/core';
//* Helpers
import { getPageNumbers } from './functions';

//* Style
import PaginationStyle from './style';

const Pagination = ({
	total,
	className,
	pageSize,
	onCategoryChange,
	pageNumbersToShow,
	prevIconName = 'left-arrow',
	nextIconName = 'right-arrow',
	currentRefinement = 1,
}) => {
	//! Next Navigation
	const searchParams = useSearchParams();

	//! Current Page
	const currentPage = useMemo(
		() => Number(searchParams.get('page')) || currentRefinement || 1,
		[searchParams, currentRefinement]
	);

	//! Last Page
	const isLastPage = currentPage * pageSize >= total;

	//! Page Numbers
	const pageNumbers = getPageNumbers({ currentPage, pageSize, total, pageNumbersToShow });

	return total > pageSize ? (
		<PaginationStyle className={`pagination-wrapper ${className}`}>
			<div className={'pagination-inner-wrapper'}>
				<div
					onClick={() => onCategoryChange('page', currentPage - 1)}
					className={`prev-btn ${currentPage === 1 ? 'disable' : ''}`}>
					<Icon name={prevIconName} />
				</div>

				{pageNumbers.map((pageNumber, index) => {
					return pageNumber === '...' ? (
						<div
							key={index}
							label='ellipsis'
							className='dots'>
							&hellip;
						</div>
					) : (
						<div
							key={index}
							onClick={() => onCategoryChange('page', pageNumber)}
							className={`pagination-item ${pageNumber === currentPage ? 'active' : ''}`}>
							{pageNumber < 10 ? `0${pageNumber}` : pageNumber}
						</div>
					);
				})}

				<div
					className={`next-btn ${isLastPage ? 'disable' : ''}`}
					onClick={() => onCategoryChange('page', currentPage + 1)}>
					<Icon name={nextIconName} />
				</div>
			</div>
		</PaginationStyle>
	) : null;
};

export default Pagination;
